import { ArrowUpRight, Github, Mail } from "lucide-react";
import { PROFILE } from "@/data/content";
import { TID } from "@/constants/testIds";

const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

const Footer = () => {
    return (
        <footer className="relative border-t border-white/[.06] bg-[#050505]">
            <div className="container-x py-16 md:py-24">
                <div className="grid gap-12 md:grid-cols-12">
                    <div className="md:col-span-6">
                        <h3
                            className="text-4xl font-semibold tracking-tighter text-white sm:text-5xl md:text-6xl"
                            style={{ fontFamily: "'General Sans', sans-serif" }}
                        >
                            {PROFILE.name}.
                        </h3>
                        <p className="mt-3 max-w-md text-base text-brand-muted">{PROFILE.signature}</p>
                    </div>
                    <div className="md:col-span-3">
                        <p className="overline mb-4">Contact</p>
                        <a
                            data-testid={TID.footerEmailLink}
                            href={`mailto:${PROFILE.email}`}
                            className="group inline-flex items-center gap-2 text-sm text-white transition-colors hover:text-brand-primary"
                        >
                            <Mail className="h-4 w-4" />
                            {PROFILE.email}
                            <ArrowUpRight className="h-3.5 w-3.5 opacity-60 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
                        </a>
                        <a
                            data-testid={TID.footerGithubLink}
                            href={PROFILE.github}
                            target="_blank"
                            rel="noreferrer"
                            className="group mt-3 inline-flex items-center gap-2 text-sm text-white transition-colors hover:text-brand-primary"
                        >
                            <Github className="h-4 w-4" />
                            github.com/Mn2902
                            <ArrowUpRight className="h-3.5 w-3.5 opacity-60 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
                        </a>
                    </div>
                    <div className="md:col-span-3">
                        <p className="overline mb-4">Navigate</p>
                        <ul className="space-y-2 text-sm text-brand-muted">
                            <li>
                                <a href="#about" className="transition-colors hover:text-white">
                                    About
                                </a>
                            </li>
                            <li>
                                <a href="#projects" className="transition-colors hover:text-white">
                                    Work
                                </a>
                            </li>
                            <li>
                                <a href="#services" className="transition-colors hover:text-white">
                                    Services
                                </a>
                            </li>
                            <li>
                                <a href="#contact" className="transition-colors hover:text-white">
                                    Contact
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="mt-16 flex flex-col-reverse items-start justify-between gap-4 border-t border-white/[.06] pt-6 md:flex-row md:items-center">
                    <p className="text-xs text-brand-muted">
                        © {new Date().getFullYear()} {PROFILE.name}. All rights reserved.
                    </p>
                    <button
                        data-testid={TID.footerBackTop}
                        onClick={scrollTop}
                        className="inline-flex items-center gap-2 text-xs font-medium text-white transition-colors hover:text-brand-primary"
                    >
                        Back to top
                        <span aria-hidden className="rotate-[-45deg]">
                            <ArrowUpRight className="h-4 w-4" />
                        </span>
                    </button>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
